import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Megaphone } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { ComposerModal } from './ComposerModal';
import { Toaster } from 'sonner';
import { IdentityGate } from './IdentityGate';
import { useApp } from './store';
export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const {
    composerOpen,
    openComposer,
    closeComposer,
    config,
    hasIdentity,
    isBrowsingOnly
  } = useApp();
  const location = useLocation();
  const announcement = config.announcement;
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <div className="min-h-screen bg-navy-50/60 flex selection:bg-gold-200 selection:text-navy-900" data-id="element-172">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} onCreatePost={openComposer} data-id="element-173" />

      <div className="flex-1 min-w-0 flex flex-col" data-id="element-174">
        <TopBar onMenuClick={() => setSidebarOpen(true)} data-id="element-175" />

        {announcement.enabled && announcement.message.trim() && <div role="status" className={`flex items-center gap-2.5 px-4 sm:px-6 py-2.5 text-sm font-medium ${announcement.tone === 'gold' ? 'bg-gold-500 text-navy-900' : 'bg-navy-600 text-white'}`} data-id="element-176">
            <Megaphone className="w-4 h-4 shrink-0" data-id="element-177" />
            <span data-id="element-178">{announcement.message}</span>
          </div>}

        <main className="flex-1 px-4 sm:px-6 lg:px-8 py-6" data-id="element-179">
          <div className="max-w-[1400px] mx-auto" data-id="element-180">
            <Outlet data-id="element-181" />
          </div>
        </main>
      </div>

      <ComposerModal open={composerOpen} onClose={closeComposer} data-id="element-182" />

      {/* First-visit, no-password identity picker (remembered per browser).
            Hidden while the visitor is "just browsing" read-only, and re-shown
            if they later try to post. */}
      {!hasIdentity && !isBrowsingOnly && <IdentityGate data-id="element-183" />}
      <Toaster position="top-right" data-id="element-184" />
    </div>;
}